import React, { useEffect, useState } from "react";
import { Form, Divider, Input, Select, InputNumber } from 'antd';
import { DataProvider } from "../../DataProvider";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";

const PackageDetails = ({ formRef, disabled, initialValues }) => {
    const dataProvider = new DataProvider()
    const [width, setWidth] = useState(0);
    const [length, setLength] = useState(0);
    const [areaRequired, setAreaRequired] = useState(0);

    const [mstDiscipline, setMstDiscipline] = useState([]);
    const [mstShipmentStatus, setMstShipmentStatus] = useState([]);
    const [mstPackingType, setMstPackingType] = useState([]);

    const masterDataMapping = {
        "MstDiscipline": setMstDiscipline,
        "MstShipmentStatus": setMstShipmentStatus,
        "MstPackingType": setMstPackingType
    };

    const fetchDropdownValues = () => {
        Object.keys(masterDataMapping).forEach((model, index) => {
            dataProvider.getDropdownValues(model)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            const setter = masterDataMapping[model];
                            setter(data.results)
                        })
                    } else {
                        response.json().then((responseJson) => {
                            openNotification("error", "Error", responseJson["message"]);
                        });
                    }
                }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
        })
    }

    useEffect(() => {
        if(initialValues && initialValues["area_required"])
            formRef.current.setFieldsValue({area_required : initialValues["area_required"]})    
        else{    
            setAreaRequired(width*length);
            formRef.current.setFieldsValue({area_required :width*length})
        }
    }, [length, width])

    useEffect(() => {
        fetchDropdownValues();
    }, [])

    return (<>
        <div className="col-lg-6 col-md-12">
            <Form.Item required name="package_no" label="Package Number">
                <Input
                    placeholder="Enter Package Number"
                    disabled={disabled} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item required name="lot_no" label="Lot Number">
                <Input
                    placeholder="Enter Lot Number"
                    disabled={disabled} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item name="cargo_name" label="Cargo Name">
                <Input
                    placeholder="Enter Cargo Name"
                    disabled={disabled}/>
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item required name="packing_type" label="Packing Type">
                <Select
                    allowClear
                    showSearch
                    placeholder="Select Packing Type"
                    disabled={disabled}
                    optionFilterProp="label"
                    options={mstPackingType.map((val) => ({
                        value: val.id,
                        label: val.packing_type,
                    }))} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item required name="discipline" label="Discipline">
                <Select
                    allowClear
                    showSearch
                    placeholder="Select Discipline"
                    disabled={disabled}
                    optionFilterProp="label"
                    options={mstDiscipline.map((val) => ({
                        value: val.id,
                        label: val.discipline_name,
                    }))} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item name="supplier_sales_order_no" label="Supplier's Sales Order Number">
                <Input
                    placeholder="Enter Supplier's Sales Order Number"
                    disabled={disabled} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item required name="supplier_wbs_no" label="Supplier's WBS Number">
                <Input
                    placeholder="Enter Supplier's WBS Number"
                    disabled={disabled} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item name="supplier_activity_no" label="Supplier's Activity Number">
                <Input
                    placeholder="Enter Supplier's Activity Number"
                    disabled={disabled} />
            </Form.Item>
        </div>
        <Divider />
        <div className="col-lg-6 col-md-12">
            <Form.Item name="amns_po_no" label="AM/NS's Purchase Order Number">
                <Input
                    placeholder="Enter AM/NS's Purchase Order Number"
                    disabled={disabled} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item name="amns_wbs_no" label="AM/NS's WBS Number">
                <Input
                    placeholder="Enter AM/NS's WBS Number"
                    disabled={disabled} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item name="amns_activity_no" label="AM/NS's Activity Number">
                <Input
                    placeholder="Enter AM/NS's Activity Number"
                    disabled={disabled} />
            </Form.Item>
        </div>
        <div className="col-lg-6 col-md-12">
            <Form.Item required name="shipment_status" label="Current Shipment Status">
                <Select
                    allowClear
                    showSearch
                    placeholder="Select Shipment Status"
                    disabled={disabled}
                    optionFilterProp="label"
                    options={mstShipmentStatus.map((val) => ({
                        value: val.id,
                        label: val.shipment_status,
                    }))} />
            </Form.Item>
        </div>
        <Divider />
        <div className="col-lg-4 col-md-12">
            <Form.Item required name="length" label="Length">
                <InputNumber
                    placeholder="Enter Length"
                    disabled={disabled} addonAfter="m"
                    onChange={(value) => setLength(value)}
                    style={{width: '100%'}}/>

            </Form.Item>
        </div>
        <div className="col-lg-4 col-md-12">
            <Form.Item required name="width" label="Width">
                <InputNumber
                    placeholder="Enter Width"
                    disabled={disabled} addonAfter="m"
                    onChange={(value) => setWidth(value)}
                    style={{width: '100%'}}/>

            </Form.Item>
        </div>
        
        <div className="col-lg-4 col-md-12">
            <Form.Item required name="area_required" label="Area Required" id="area_required">
                <InputNumber
                    placeholder="Enter Area Required"
                    disabled={true}
                    // value={initialValues["area_required"] ? initialValues["area_required"] : areaRequired}
                    addonAfter={<>m<sup>2</sup></>}
                    style={{width: '100%'}}/>
            </Form.Item>
        </div>

        <div className="col-lg-4 col-md-12">
            <Form.Item required name="height" label="Height">
                <Input
                    placeholder="Enter Height"
                    disabled={disabled} addonAfter="m"/>
            </Form.Item>
        </div>
        
        <div className="col-lg-4 col-md-12">
            <Form.Item required name="net_weight" label="Net Weight">
                <Input
                    placeholder="Enter Net Weight"
                    disabled={disabled} addonAfter="Kg" />
            </Form.Item>
        </div>
        <div className="col-lg-4 col-md-12">
            <Form.Item required name="gross_weight" label="Gross Weight">
                <Input
                    placeholder="Enter Gross Weight"
                    disabled={disabled} addonAfter="Kg" />
            </Form.Item>
        </div>
        
    </>
    )
}

export default PackageDetails;